import React, { useState, useEffect } from 'react'
import { Grid, Typography } from '@material-ui/core/'
import { Illustrations, Mailings, Analytics, Reported, Podcasts } from './components/CategoryAdminPage'
import { logOut } from '../../modules/session/actions'
import { adminMenu } from './constants'
import { useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import c from 'classnames'
import './index.scss'

const Admin = () => {
  const { categoryPage } = useParams()
  const [activeColor, setActiveColor] = useState('illustrations')
  const [addHover, setAddHover] = useState('')
  const history = useHistory()
  const dispatch = useDispatch()
  const [typePage, setTypePage] = useState(null)

  const goTo = path => history.push(path)

  const categoryPages = {
    illustrations: () => <Illustrations />,
    mailings: () => <Mailings />,
    analytics: () => <Analytics typePage={typePage} setTypePage={setTypePage} />,
    reported: () => <Reported setTypePage={setTypePage} />,
    podcasts: () => <Podcasts />,
  }

  const content = categoryPages?.[categoryPage] || categoryPages?.illustrations


  const onLogout = () => {
    dispatch(logOut(null))
    history.push('/')
  }

  useEffect(() => {
    if (typePage) {
      setActiveColor('analytics')
    }
  }, [typePage])

  useEffect(() => {
    setActiveColor(categoryPage)
  }, [categoryPage])

  return (
    <Grid className='generalAdminWrapper'>
      <Grid className='adminWrapper'>
        <Grid className='adminDashboard'>
          <Grid className='itemBlock'>
            {adminMenu?.map(({ iconMenu, title, label, id }) => (
              <Grid
                key={id}
                onMouseLeave={() => setAddHover('')}
                onMouseMove={() => setAddHover(label)}
                className={c('itemMenu', activeColor === label && 'activeItem')}
                onClick={() => {
                  setActiveColor(label)
                  goTo(`/admin/${label}`)
                }}
              >
                {iconMenu({ color: activeColor === label ? '#2196F3' : addHover === label ? '#2196F3' : '#757575' })}
                <Typography className='titleItem'>{title}</Typography>
              </Grid>
            ))}
          </Grid>
          <Grid className='borderDasboard' onClick={onLogout}>
            Logout
          </Grid>
        </Grid>
        {content()}
      </Grid>
    </Grid>
  )
}

export default Admin
